<template>
  <v-card>
    <v-card-title class="secondary white--text">
      {{title}}
      <v-spacer></v-spacer>

      <v-btn
        small
        color="warning"
        @click="createRevision()"
        v-if="canCreateRevisions && !revisions.length"
        class="mr-4"
      >
        <v-icon small class="mr-2">fa-plus</v-icon>Revision
      </v-btn>

      <v-btn icon dark @click="show=!show">
        <v-icon v-if="show">fa-minus</v-icon>
        <v-icon v-else>fa-chevron-down</v-icon>
      </v-btn>
    </v-card-title>

    <v-expand-transition>
      <div class v-show="show">
        <v-container class="secondary pt-4 white--text" v-if="revisions.length">
          <!-- Section for revision info !-->
          <v-row v-for="(revision,i) in revisions" :key="i" align="start">
            <v-col cols="12" md="2" class="text-center">
              <revision-video v-model="revision.video"></revision-video>
            </v-col>
            <v-col cols="10" md="9" class="pr-1">
              <v-textarea
                dark
                outlined
                v-model="revision.note"
                label="Revision message from editor"
              ></v-textarea>
            </v-col>
            <v-col cols="2" md="1" class="text-right">
              <v-btn icon dark @click="deleteRevision(revision)">
                <v-icon>fa-times</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
        <v-container class="py-0">
          <v-row v-if="single" justify="center">
            <v-col cols="12" md="10" v-for="(video,i) in videos" :key="'v'+i">
              <v-card class="clicky">
                <div class="video-responsive secondary">
                  <video controls :poster="video.thumbnail ? video.thumbnail : '/placeholder.png'">
                    <source :src="video.url" type="video/mp4" />
                    <source :src="video.url" type="video/ogg" />Your browser does not support HTML5 video.
                  </video>
                </div>
                <v-card-actions class="blue white--text py-0" v-if="video.is_revision===1">
                  <h5>Revision</h5>
                </v-card-actions>
                <v-card-actions
                  class="grey lighten-3 py-0"
                  v-if="canCreateRevisions && revisions.length"
                >
                  <v-checkbox
                    label="Request Revision"
                    color="warning"
                    :true-value="1"
                    :false-value="0"
                    v-model="video.revision_required"
                  ></v-checkbox>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>

          <v-row v-else>
            <v-col cols="6" md="4" lg="4" v-for="(video,i) in videos" :key="'v'+i">
              <v-card class="clicky">
                <div class="video-responsive secondary">
                  <video controls :poster="video.thumbnail ? video.thumbnail : '/placeholder.png'">
                    <source :src="video.url" type="video/mp4" />
                    <source :src="video.url" type="video/ogg" />Your browser does not support HTML5 video.
                  </video>
                </div>
                <v-card-actions class="blue white--text py-0" v-if="video.is_revision===1">
                  <h5>Revision</h5>
                </v-card-actions>
                <v-card-actions
                  class="grey lighten-3 py-0"
                  v-if="canCreateRevisions && revisions.length"
                >
                  <v-checkbox
                    label="Request Revision"
                    color="warning"
                    :true-value="1"
                    :false-value="0"
                    v-model="video.revision_required"
                  ></v-checkbox>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </v-expand-transition>
  </v-card>
</template>
<script>
import revisionVideo from "./revision-video";
export default {
  name: "",
  components: {
    revisionVideo,
  },
  props: ["videos", "revisions", "title", "can_create_revisions", "single"],
  data: () => ({
    show: true,
  }),
  computed: {
    canCreateRevisions() {
      return this.can_create_revisions;
    },
  },
  methods: {
    createRevision() {
      this.show = true;
      this.$emit("create-revision");
    },
    deleteRevision(revision) {
      this.$emit("delete-revision", revision);
    },
  },
};
</script>
<style lang="scss" scoped>
.video-responsive {
  overflow: hidden;
  padding-bottom: 56.25%;
  position: relative;
  height: 0;
}
.video-responsive video {
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  position: absolute;
}
</style>
